// extracted by mini-css-extract-plugin
export default {"productGallery":"RD-z","inQuickShop":"SD-z"};